import { Component, OnInit } from '@angular/core';
import { Canal } from '../../_models/canal';
import { ListaItem } from '../../_models/lista-item';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CanalService } from '../../_services/canal.service';
import { NavService } from '../../_services/_nav.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';

@Component( {
  selector: 'app-canales-editar',
  templateUrl: 'canales-editar.component.html'
} )

export class CanalesEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  codShivamExiste = false;
  guardando = false;
  canal: Canal;
  lisCanales: Canal[] = [];
  tabSeleccionado = 'INFO';
  lisTipoCanal: SelectItem[] = [];
  formulario: FormGroup;
  submitted = false;

  constructor( private lisServicio: ListaService,
               private nav: NavService,
               private canServicio: CanalService,
               private location: Location,
               private conServicio: ConfirmationService,
               private route: ActivatedRoute,
               private fb: FormBuilder ) {
  }

  ngOnInit(): void {

    this.lisServicio.getMasterDetails( 'ListasTiposCanales' ).subscribe( lisTipoCanales => {
      lisTipoCanales.map( ( s: ListaItem ) => {
        this.lisTipoCanal.push( { label: s.nombre, value: s.idLista } );
      } );

      if ( this.lisTipoCanal.length === 0 ) {
        this.nav.setMesage( 4, {
          severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.nav.buscarMensaje( 'LISTAS.MSG_NOEXISTE' )
        } );
      }

    }, error => {
      this.nav.setMesage( 4, {
        severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( 'LISTAS.MSG_NOEXISTE' )
      } );
    } );

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.canServicio.obtenerPorId( params[ 'id' ] ).subscribe( canal => {
          if (canal) {
            this.canal = canal;
          }

          this.carServicios();
        } );
      } else {
        this.carServicios();
      }
    } );
  }


  carServicios() {
    this.formulario = this.fb.group( {
      idCanal: [ this.canal ? this.canal.idCanal : null ],
      codigo: [ this.canal ? this.canal.codigo : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      nombre: [ this.canal ? this.canal.nombre : null, [ Validators.required, Validators.maxLength( 100 ) ] ],
      codigoShivam: [ this.canal ? this.canal.codigoShivam : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      idTipoCanal: [ this.canal ? this.canal.idTipoCanal : null, Validators.required ],
      indicadorHabilitado: [ this.canal ? this.canal.indicadorHabilitado : true ],
      indicadorDinero: [ this.canal ? this.canal.indicadorDinero : false ],
      indicadorRestriccionGestion: [ this.canal ? this.canal.indicadorRestriccionGestion : false ],
      indicadorActDatosTercero: [ this.canal && this.canal.indicadorActDatosTercero ? this.canal.indicadorActDatosTercero : false ],
      indicadorTelefonoOtp: [ this.canal ? this.canal.indicadorTelefonoOtp : false ],
      indicadorCorreoOtp: [ this.canal ? this.canal.indicadorCorreoOtp : false],
      indicadorFreelance: [ this.canal ? this.canal.indicadorFreelance : false],
      indicadorScore: [ this.canal ? this.canal.indicadorScore : false],
      indicadorEjecutivo: [ this.canal ? this.canal.indicadorEjecutivo : false]
    } );

    this.canServicio.listadoCanales().subscribe( canales => {
      this.lisCanales = canales;
      this.carInformacionInicial = false;
    } );
  }


  onSubmit() {
    this.submitted = true;
    const canal = this.formulario.value;
    this.guardando = true;
    if(!this.f.indicadorEjecutivo.value && !this.f.indicadorFreelance.value){
      this.nav.setMesage( 0, {
        severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( 'CANALES.MSG_ERRORFUERZACOMERCIAL' )
      } );
      this.guardando = false;
      return;
    }
    if ( !this.codExiste && !this.codShivamExiste && this.formulario.valid ) {
      const canDinero = this.lisCanales.find( x => x.indicadorDinero && this.f.idCanal.value !== x.idCanal );
      if ( this.f.indicadorDinero.value && canDinero ) {
        this.conServicio.confirm( {
          message: this.nav.buscarMensaje( 'CANALES.MSG_EXISTEDINERO' ),
          header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
          icon: 'fa fa-question-circle',
          accept: () => {
            this.guardarCanal( canal, canDinero );
          },
          reject: () => {
            this.guardando = false;
          }
        } );
      } else {
        this.guardarCanal( canal );
      }
    } else {
      this.guardando = false;
    }
  }


  guardarCanal( canal: Canal, canDinero?: Canal ) {
    if ( canal.idCanal !== '' && canal.idCanal !== null && canal.idCanal !== undefined ) {
      this.canServicio.actualizar( canal ).subscribe( rta => {
        this.canal = canal;
        this.verificarDineroExistente( 2, canDinero );
      }, error => {
        this.nav.setMesage( 3 ) ;
        this.guardando = false;
      } );
    } else {
      this.canServicio.crear( canal ).subscribe( rta => {
        this.canal = canal;
        this.canal.idCanal = rta.idCanal;
        this.f.idCanal.setValue( rta.idCanal );
        this.verificarDineroExistente( 1, canDinero );
      }, error => {
        this.nav.setMesage( 3 );
        this.guardando = false;
      } );
    }
  }


  verificarDineroExistente( tipMensaje: number, canDinero?: Canal ) {
    if ( canDinero ) {
      canDinero.indicadorDinero = false;
      this.canServicio.actualizar( canDinero ).subscribe( actEstado => {
        const a = this.lisCanales.findIndex( x => x.idCanal === canDinero.idCanal );
        if ( a >= 0 ) {
          this.lisCanales[ a ] = canDinero;
        }
        this.nav.setMesage( tipMensaje );
        this.guardando = false;
        this.tabSeleccionado = 'PRO';
      } );
    } else {
      this.nav.setMesage( tipMensaje );
      this.guardando = false;
      this.tabSeleccionado = 'PRO';
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisCanales.find( x => x.codigo === this.f.codigo.value && (!this.canal || this.canal.idCanal !== x.idCanal) ) ? true : false;
  }

  validarCodigoShivam() {
    this.codShivamExiste = this.lisCanales.find( x => x.codigoShivam === this.f.codigoShivam.value && (!this.canal || this.canal.idCanal !== x.idCanal) ) ? true : false;
  }

  get f() {
    return this.formulario.controls;
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'PRO';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'ROL';
        break;
      }
      case 3: {
        this.tabSeleccionado = 'RESGESXEST';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }
}
